module.exports = __webpack_public_path__ + "/login_ui/img/bn-48c19236b4a7432ed1c7e7074756af55.svg";